export default __webpack_public_path__ + "static/media/logo_light.d0e11cc0.png";